import DepsService from 'services/dependencies';

const CONTEXT = 'dashboard';

export const fetchTop10 = (retailerId) => {
  const { url } = DepsService.rest.widgets.instant.top10;
  const queryParams = {};
  const urlParams = { retailerId };
  const path = 'widgets.instant.top10';

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams, path);
};

export const fetchTopSellersByPrice = (retailerId) => {
  const { url } = DepsService.rest.widgets.instant.topSellersByPrice;
  const queryParams = {};
  const urlParams = { retailerId };
  const path = 'widgets.instant.top10';

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams, path);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/top-selling-games.api.js